<template>
  <el-main>
    <ext-users />
  </el-main>
</template>

<script>
  // components
  import ExtUsers from './extUsers/ExtUsers';

  export default {
    name: 'PageContent',
    components: {
      ExtUsers
    },
  }
</script>
